import {
  Box,
  Button,
  Col,
  HiddenSearch,
  Row,
  Search,
  Select,
} from '@cubeyou-team/hx-react-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { getCurrentProductDataSources } from 'src/selectors/myCompany';
import { isEmpty } from 'src/utils';
import {
  StyledContainer,
  StyledSearchContainer,
  StyledSelectContainer,
} from './StyledRepositoryFilters';
import { useFilters } from './hooks/useFilters';
import { useMRISimmons } from '../../modules/audience-activation/hooks/useMriSimmons';

const RepositoryFilters = ({
  filter,
  onFilterChange,
  search,
  onSearchChange,
  onNewFolderCreate,
}) => {
  const repositorySize = useSelector(state => state.layout.repositorySize);
  const productDataSources = useSelector(state =>
    getCurrentProductDataSources(state)
  );
  const isMyCompanyLoading = useSelector(state => state.myCompany.isLoading);
  const [searchIsOpen, setSearchOpen] = useState(false);

  const { isMriSimmonsActivated } = useMRISimmons();

  const { filters } = useFilters({
    filter,
    onFilterChange,
    productDataSources,
    isMyCompanyLoading,
    isMriSimmonsActivated,
  });

  const selectedFilter = filters.find(filter => filter.isActive);
  const filterIcon =
    !isEmpty(productDataSources) && selectedFilter && selectedFilter.iconLeft;

  if (repositorySize === 'full') {
    return (
      <Box pY="medium" pX="small" borderSize="2px" borderPosition="bottom">
        <Row>
          <Col span={3}>
            <Select
              data-test="filters-open"
              onItemChange={value => {
                onFilterChange(value);
              }}
              options={filters}
              headerIcon={filterIcon}
              disabled={isMyCompanyLoading}
            />
          </Col>
          <Col span={3}>
            <Search
              delay={500}
              onSearchChange={onSearchChange}
              initialValue={search}
              placeholder="Search"
              size="small"
            />
          </Col>
          <Col span="auto">
            <Button
              icon="add"
              onClick={onNewFolderCreate}
              size="small"
              variant="subtle"
            >
              New Folder
            </Button>
          </Col>
        </Row>
      </Box>
    );
  }

  return (
    <Box pY="medium" pX="small" borderSize="2px" borderPosition="bottom">
      <StyledContainer open={searchIsOpen}>
        <StyledSelectContainer>
          <Select
            data-test="filters-open"
            onItemChange={value => {
              onFilterChange(value);
            }}
            options={filters}
            headerIcon={filterIcon}
            disabled={isMyCompanyLoading}
          />
        </StyledSelectContainer>
        <StyledSearchContainer open={searchIsOpen}>
          <HiddenSearch
            delay={500}
            onSearchChange={onSearchChange}
            initialValue={search}
            initialOpenState={searchIsOpen}
            placeholder="Search"
            size="small"
            onSearchToggle={open => setSearchOpen(open)}
          />
        </StyledSearchContainer>
      </StyledContainer>
    </Box>
  );
};

export default RepositoryFilters;
